import useSWR from "swr";
import { axiosInstance } from "../axiosConfig";
import { QueryData } from "../types/QueryData.interface";

interface SaleResponse {
  data: {
    name: string;
    price: number;
  }[];
  error: {
    code: string;
    message: string;
  };
}

interface TestResultResponse {
  data: {
    totalEq: number;
    stressEq: number;
    relationEq: number;
    motivationEq: number;
    whiteWashEq: number;
    whiteWashExplain: string;
  };
  error: {
    code: string;
    message: string;
  };
}

const TEST_SALE_KEY = "/sale";
const BASE_URL = "/tests";
const TEST_RESULT_KEY = "/result";
const fetcher = async (url: string): Promise<SaleResponse> =>
  axiosInstance.get(url).then((resp) => resp.data);

const useGetPrices = (): QueryData<SaleResponse> => {
  return useSWR<SaleResponse>(`${BASE_URL}${TEST_SALE_KEY}`, fetcher);
};
const fetchTestResults = async (url: string): Promise<TestResultResponse> =>
  axiosInstance.get(url).then((resp) => resp.data);
const useGetTestResults = (isn: string): QueryData<TestResultResponse> => {
  const url = !!isn ? `${BASE_URL}${TEST_RESULT_KEY}/${isn}` : null;
  return useSWR<TestResultResponse>(url, fetchTestResults);
};

export { useGetPrices, useGetTestResults };
